
import React, { useState, useEffect, useContext } from 'react';
import {Routes, Route, useNavigate, Link} from 'react-router-dom';
import '../App.css';
import { ethers } from 'ethers';
import $ from 'jquery';
import axios from 'axios';
// Navbar components
  import { checkWalletStatus, getPreviousWallets, checkPreviousWalletExists, subscribeToWallets, autoSelectWallet, getPageName, listenForAccountChanges, listenForChainChanges, connectWallet, switchNetwork, switchToCorrectChain, switchNavConnectButtonText, selectivePageRefresh, mainButtonSwitcher, bchainCheckAndButtonControl } from '../ResponsiveAppBar';
//   import { connectBlockchain } from './Browse';

import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
// import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import HelpOutline from '@mui/icons-material/HelpOutline';
import Typography from '@mui/material/Typography';
import FormHelperText from '@mui/material/FormHelperText';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';

///////// Virtualized search window
  // import * as React from 'react';
  import PropTypes from 'prop-types';
  // import TextField from '@mui/material/TextField';
  import Autocomplete, { autocompleteClasses } from '@mui/material/Autocomplete';
  import useMediaQuery from '@mui/material/useMediaQuery';
  import ListSubheader from '@mui/material/ListSubheader';
  import Popper from '@mui/material/Popper';
  import { useTheme, styled } from '@mui/material/styles';
  import { VariableSizeList } from 'react-window';
  // import Typography from '@mui/material/Typography';
/////////

import ProjectType1 from '../artifacts/contracts/ProjectType1.sol/ProjectType1.json';

// TEAMS smart contract address (Polygon)
	// const CONTRACT_TEAMS_ADDRESS_TEST_ONLY = process.env.REACT_APP_TEAMS_CONTRACT_ADDRESS_LOCAL;
	// console.log("Check CONTRACT_TEAMS_ADDRESS_TEST_ONLY: " + CONTRACT_TEAMS_ADDRESS_TEST_ONLY);

// Set base URLs & IDs
    let CONTRACT_ADDRESS, USER_API_ENDPOINT_ROOT, TEAMS_API_ENDPOINT_ROOT, API_ENDPOINT_ROOT, UPLOADS_FOLDER, UPLOADS_FOLDER_URL, PROVIDER_URL, ASSETS_FOLDER, NETWORK_CHAIN_ID;

    if (process.env.NODE_ENV === "development") {
        console.log("local environment");
		CONTRACT_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS_LOCAL;
		USER_API_ENDPOINT_ROOT = process.env.REACT_APP_USER_API_ENDPOINT_ROOT_LOCAL;
		TEAMS_API_ENDPOINT_ROOT = process.env.REACT_APP_TEAMS_API_ENDPOINT_ROOT_LOCAL;
        API_ENDPOINT_ROOT = process.env.REACT_APP_API_ENDPOINT_ROOT_LOCAL;
        PROVIDER_URL = process.env.REACT_APP_PROVIDER_URL_LOCAL;
		UPLOADS_FOLDER = process.env.REACT_APP_UPLOADS_FOLDER_LOCAL;
		UPLOADS_FOLDER_URL = process.env.REACT_APP_UPLOADS_FOLDER_URL_LOCAL;
        ASSETS_FOLDER = process.env.REACT_APP_ASSETS_FOLDER_LOCAL;
        NETWORK_CHAIN_ID = process.env.REACT_APP_NETWORK_CHAIN_ID_LOCAL;      
    } else {
        console.log("production environment");
		CONTRACT_ADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS_PRODUCTION;
		USER_API_ENDPOINT_ROOT = process.env.REACT_APP_USER_API_ENDPOINT_ROOT_PRODUCTION;
		TEAMS_API_ENDPOINT_ROOT = process.env.REACT_APP_TEAMS_API_ENDPOINT_ROOT_PRODUCTION;
        API_ENDPOINT_ROOT = process.env.REACT_APP_API_ENDPOINT_ROOT_PRODUCTION;
        PROVIDER_URL = process.env.REACT_APP_PROVIDER_URL_PRODUCTION;
		UPLOADS_FOLDER = process.env.REACT_APP_UPLOADS_FOLDER_PRODUCTION;
		UPLOADS_FOLDER_URL = process.env.REACT_APP_UPLOADS_FOLDER_URL_PRODUCTION;
        ASSETS_FOLDER = process.env.REACT_APP_ASSETS_FOLDER_PRODUCTION;
        NETWORK_CHAIN_ID = process.env.REACT_APP_NETWORK_CHAIN_ID_PRODUCTION;
    }

// Global variable
	let onLoad_global = false;

// For dividers with text
	const Root = styled('div')(({ theme }) => ({
		color: 'lightgray',
		width: '100%',
		...theme.typography.body2,
		'& > :not(style) ~ :not(style)': {
			marginTop: theme.spacing(2),
		},
	}));

// PROXY trigger
	// Proxy variables (GLOBAL)
		let proxy;
		let proxyVar;
		let recoonectInSkipMode_global = false;
	// Reset blockchain connection
	export function resetConnection1(_mode = null) {
		console.log("resetConnection1 triggered");
		if (_mode == 'skip wallet prompt') {
			recoonectInSkipMode_global = true;
		} else {
			recoonectInSkipMode_global = false;
		}
		let randomNumber = Math.random();
		proxy.proxyVar = randomNumber;
	}

// Main blockchain button switching
	// export function mainButtonSwitcher(show) {
	// 	console.log("Main button switcher triggered. 'Show' = " + show);
	// 	setTimeout(function() {
	// 		$(".bchain-button").hide();
	// 		$(".connect-wallet-button").hide();
	// 		$(".switch-chain-button").hide();
	// 		$(".bchain-help-section").hide();
	// 		if (show == "bchain") { $(".bchain-button").show(); }
	// 		if (show == "connect") { $(".connect-wallet-button").show(); }
	// 		if (show == "switch") { $(".switch-chain-button").show(); }
	// 		if (show != "bchain") { $(".bchain-help-section").show(150); }

	// 	}, 1000); // delay of 1 sec
	// }

// Switch to BASE network
	export async function handleNetworkSwitch() {

		// const switchResult = await switchNetwork(); // new 7/1/25
		// if (switchResult == 'error') {
		// 	alert("Could not switch network!")
		// 	$(".bchain-button").hide();
		// 	$(".connect-wallet-button").show();
		// 	$(".switch-chain-button").hide();
		// }

		//----
		// try {
		// 	console.log("= * * * = = = Try switching network/chain");
		// 	await window.ethereum.request({
		// 		method: 'wallet_switchEthereumChain',
		// 		params: [{ chainId: NETWORK_CHAIN_ID }],
		// 	})
		// 	//   checkWallet(); // redundant / delete? (since done automatically?)
		// } catch(err) {
		// 	console.log('Network switch failed (not found)');
		// 	if (err.code === 4902) { // if network not found, add it
		// 		const networkSwitched = await switchNetwork(); // new 7/1/25
		// 		if (networkSwitched == true) {
		// 			//
		// 		}
		// 		// connectWallet('noreset'); // imported from navbar
		// 	} else {
		// 		alert("Could not switch network!")
		// 		$(".bchain-button").hide();
		// 		$(".connect-wallet-button").show();
		// 		$(".switch-chain-button").hide();
		// 	}
		// }
	}

// Hash string Solidity style (keccak256)
	export async function hashSolidityStyle(_string) {
		// (Note: "toUtf8Bytes" matches Solidity's "encodePacked")
		let stringBytes = ethers.utils.toUtf8Bytes(_string);
		let hashedString = ethers.utils.keccak256(stringBytes);
		return hashedString;
	}

// Hash data - SHA-256
	export async function hashData(_data) { 
		return new Promise((resolve, reject) => {
			let postData = {
				original_data: _data,
			};
			axios({ 
				url: API_ENDPOINT_ROOT + "hash-function.php",
				method: "POST",
				data: JSON.stringify(postData),
			})
			.then((res) => { 
				const returned_data = res.data.hash;
				console.log("Returned hashed data: ", returned_data);
				resolve(returned_data);
			}) 
			.catch((err) => { console.log("error response: " + err) });
		});
	}



///////// Virtualized search box

    const LISTBOX_PADDING = 8; // 8 px

    function renderRow(props) {
        const { data, index, style } = props;
        const dataSet = data[index];
        const inlineStyle = {
            ...style,
            top: style.top + LISTBOX_PADDING,
        };
        if (dataSet.hasOwnProperty('group')) {
            return (
              <ListSubheader key={dataSet.key} component="div" style={inlineStyle}>
                  {dataSet.group}
              </ListSubheader>
            );
        }
        return (
            <Typography component="li" {...dataSet[0]} noWrap style={inlineStyle}>
                {dataSet[1]}
            </Typography>
        );
    }

    const OuterElementContext = React.createContext({});

    const OuterElementType = React.forwardRef((props, ref) => {
        const outerProps = React.useContext(OuterElementContext);
        return <div ref={ref} {...props} {...outerProps} />;
    });

    function useResetCache(data) {
        const ref = React.useRef(null);
        React.useEffect(() => {
            if (ref.current != null) {
              ref.current.resetAfterIndex(0, true);
            }
        }, [data]);
        return ref;
    }

    // Adapter for react-window
    const ListboxComponent = React.forwardRef(function ListboxComponent(props, ref) {
        const { children, ...other } = props;
        const itemData = [];
        children.forEach((item) => {
          itemData.push(item);
          itemData.push(...(item.children || []));
        });
    
        const theme = useTheme();
        const smUp = useMediaQuery(theme.breakpoints.up('sm'), {
          noSsr: true,
        });
        const itemCount = itemData.length;
        const itemSize = smUp ? 36 : 48;
    
        const getChildSize = (child) => {
          if (child.hasOwnProperty('group')) {
              return 48;
          }
          return itemSize;
        };
    
        const getHeight = () => {
          if (itemCount > 8) {
              return 8 * itemSize;
          }
          return itemData.map(getChildSize).reduce((a, b) => a + b, 0);
        };
    
        const gridRef = useResetCache(itemCount);
    
        return (
        <div ref={ref}>
            <OuterElementContext.Provider value={other}>
            <VariableSizeList
                itemData={itemData}
                height={getHeight() + 2 * LISTBOX_PADDING}
                width="100%"
                ref={gridRef}
                outerElementType={OuterElementType}
                innerElementType="ul"
                itemSize={(index) => getChildSize(itemData[index])}
                overscanCount={5}
                itemCount={itemCount}
            >
                {renderRow}
            </VariableSizeList>
            </OuterElementContext.Provider>
        </div>
        );
    });
    //

    ListboxComponent.propTypes = {
		children: PropTypes.node,
    };

    const StyledPopper = styled(Popper)({
		[`& .${autocompleteClasses.listbox}`]: {
			boxSizing: 'border-box',
			'& ul': {
				padding: 0,
				margin: 0,
			},
		},
    });

    // Customized * * *
	let teamIndexList, searchList; // Global
	export async function getDataForSearchList(_filter = 'all') {

		console.log('getDataForSearchList triggered * * *');
		console.log('Check filter: ' + _filter);
        // Obtain user blockchain account
			const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
			const bchain_account = accounts[0];
			if (bchain_account == "error") {
				console.log("blockchain account request failed");
			}

        let postData = { filter: _filter, data: bchain_account };
        await axios({ 
            url: TEAMS_API_ENDPOINT_ROOT + "search-list-db.php",
            method: "POST",
            data: JSON.stringify(postData),
        })
		.then((res) => {
			const returned_data = JSON.parse(res.data.data);
			console.log("Check returned data: ", returned_data);
			if (returned_data !== 'empty') {
				teamIndexList = [...returned_data['team_index']]; // For creating teamKey
				searchList = [...returned_data['team_name']];
				console.log('Data for list fetched');
				finalizeSearchList(searchList);
			} else {
				searchList = [" You have no teams"]; // Keep this string consistent with OPTIONS below & "Check team selection" check below
				console.log('Team list empty');
				finalizeSearchList(searchList);
			}
		}) 
		.catch((err) => { console.log("error response: " + err) });
    }

	let OPTIONS = [" You have no teams"]; // GLOBAL, initial state (Keep this string consistent with searchList above)

    function finalizeSearchList(searchList) {
        OPTIONS = searchList.sort((a, b) => a.toUpperCase().localeCompare(b.toUpperCase()));
    }

    // getDataForList(); // call function * * * 
    // let OPTIONS; // global

    // function makeFinalList(searchList) {
    // // console.log("searchList array check: ", searchList); // check array
    // OPTIONS = searchList.sort((a, b) => a.toUpperCase().localeCompare(b.toUpperCase()));
    // }
  
///////// End virtualized search box /////////


// Get URL parameter (if included)
	// function getURLParameter(_param) {
	// 	let pageURL = window.location.search.substring(1);
	// 	let URLVariables = pageURL.split('&');
	// 	for (let i = 0; i < URLVariables.length; i++) {
	// 		let parameterName = URLVariables[i].split('=');
	// 		if (parameterName[0] == _param) {
	// 			return decodeURIComponent(parameterName[1]);
	// 		}
	// 		if (i == (URLVariables.length - 1)) {
	// 			return "empty";
	// 		}
	// 	}
	// }

// Manage Page Reload (used when switching wallet account or chain)
    // function selectivePageRefresh() {
	// 	// Full URL
	// 		const currentURL = window.location.href;
	// 	// Cut off all parameters from URL
	// 		const currentURL_noParams = currentURL.split('?')[0];
	// 	const last4Chars = currentURL_noParams.slice(-4);
	// 	const pageId = last4Chars.toLowerCase();
	// 	console.log("Page id: " + pageId);
	// 	if (pageId == "eate"|| pageId == "ate/" || pageId == "000/" || pageId == "3000" || pageId == "3001" || pageId == "001/" || pageId == "3002" || pageId == "002/") {
	// 		console.log("checkWallet should be triggered on Create page: " + pageId);
	// 		checkWallet();
	// 	} else if (pageId == "ject"|| pageId == "ect/") {
	// 		console.log("checkWallet should be triggered on Project page: " + pageId);
	// 		// connectBlockchain(); // imported from Project page
	// 	} else {
	// 		console.log("Page should reload");
	// 		window.location.reload();
	// 	}
    // }

/////////////////////


function Create() {

    // State variables
        const navigate = useNavigate();
        const [userAddress, setUserAddress] = useState();

        const [errorTitle, setErrorTitle] = useState(false);
        const [errorUsername, setErrorUsername] = useState(false);
		const [errorUserEmail, setErrorUserEmail] = useState(false);
        const [errorTasking, setErrorTasking] = useState(false);
		const [timeDateError1, setTimeDateError1] = useState(false);
		const [timeDateError2, setTimeDateError2] = useState(false);

        const [fileSelected, setFile] = useState('');
        const [isActive, setIsActive] = useState(false);
        const [isActive2, setIsActive2] = useState(false);
        const [bchainBtnDisabled, setBchainBtnDisabled] = useState(false);
        // const [timeChanged, setTimeChanged] = useState(true);
        const [psiTaskingIsHashed, setPsiTaskingHashed] = useState(false);//unused for now
        const [txHash, setTxHash] = useState(null);

        const [projectTitle, setTitle] = useState(null);
        const [username, setUsername] = useState(null);
		const [userEmail, setUserEmail] = useState(null);

		const [openTime, setOpenTime] = useState(null);
        const [closeTime, setCloseTime] = useState(null);

        const [psiTaskingText, setPsiTasking] = useState(null);
        const [psiTaskingHash, setPsiTaskingHash] = useState(null); // set but unused
        const [fileHash, setFileHash] = useState('');
        const [fileNameFinal, setFileNameFinal] = useState(null);
		const [restrictionType, setRestrictionType] = useState('open');

		const [registerUser_state, setRegisterUser] = useState(false);

        const [selectedValue, setSelectedValue] = useState(null);
        // const [inputValue, setInputValue] = useState('');
		const [teamKey, setTeamKey] = useState(null); 
		const [teamName, setTeamName] = useState(null);


	// PROXY setup (Keep track of proxyVar for function trigger)
		// Proxy handler
		let proxyHandler = {
			set: function(target, property, value) {
				target[property] = value;
				// On variable change...
					// setupBlockchain();
					if (recoonectInSkipMode_global == true) {
						setupBlockchain('skip wallet prompt');
					} else {
						setupBlockchain();
					}
					return true;
			}
		};
		// Create a proxied variable which triggers above function on change
		proxy = new Proxy({ proxyVar: proxyVar }, proxyHandler);

			
		async function setupBlockchain(_mode = null) {

			console.log("= = = = setupBlockchain() triggered = = = =");
			// setShowLatestSubmission(false); // reset JIC
			console.log("Check mode param: " + _mode);

			// Get user address & set state variable
				if (typeof window.ethereum !== 'undefined' || (typeof window.web3 !== 'undefined')) { 
					console.log("Wallet is installed");
					const wallet_accounts = await window.ethereum.request({ method: 'eth_accounts' });
					const walletAccount1 = wallet_accounts[0];
					console.log("blockchain account: " + walletAccount1);
					if (walletAccount1) { 
						console.log("User connected to wallet");
						setUserAddress(walletAccount1);
						// Get list of teams owned by user
							await getDataForSearchList('owner_address');
					}
				}

			// Check if user is connected to blockchain & manage button
				try {
					await bchainCheckAndButtonControl(_mode);
				} catch(err) {
					console.log("Error: ", err);
				}
		} 
		// End of setupBlockchain



	useEffect(() => { // First trigger for blockchain * * *
		onLoad_global = true;
		console.log("setupBlockchain() triggered on page load");
		setupBlockchain('on load');
	}, []);


	// Check lastest on-chain project info
		async function checkLatestOnchainProjectInfo() {	
			console.log("checkLatestOnchainProjectInfo triggered");
			const provider = new ethers.providers.Web3Provider(window.ethereum)
			const signer = provider.getSigner();
			const contract = new ethers.Contract(CONTRACT_ADDRESS, ProjectType1.abi, signer);
			try {
				console.log("Check 1/5")
				const bchain_account = await requestAccount();
				console.log("Check 2/5 - bchain_account: " + bchain_account);
				const maxIndex = await getMaxIndex();
				console.log("Check 3/5 - maxIndex: " + maxIndex);
				const projectKey_ = await contract.getProjectKey(bchain_account, maxIndex);
				console.log("Check 4/5 - projectKey: " + projectKey_);
				// const projectInfo = await contract.projects(projectKey_);
				const projectInfo = await contract.retrieveProjectInfo(projectKey_);
				console.log("Check 5/5 - projectInfo: ", projectInfo);
			} catch (err) {
				console.log("Error: ", err);
				console.log("checkLatestOnchainProjectInfo failed");
			}
		}
		// useEffect(() => {
		// 	checkLatestOnchainProjectInfo(); // temp (for test/checking) * * *
		// }, []);


	// Set scroll target
		let scrollTargetOffset;
		$(function() { // Wait for page to load
			const scrollTargetElement = $("#subheading");
			scrollTargetOffset = scrollTargetElement.offset().top; // Global
		});

	// Make project key
		function makeProjectKey(_index, _address) {
			let inputData = ethers.utils.defaultAbiCoder.encode(['uint256', 'address'], [_index, _address]);
			let key = ethers.utils.keccak256(inputData);
			return key;
		}

    // Set psi Tasking text
		const handleTextChange = (event) => {
		// let newText = event.target.value.replace(/\n/g, '<br/>');
		let newText = event.target.value;
		console.log('PSI Tasking text: ' + newText);
		setPsiTasking(newText);
		}; 
  
	// Get user information from user registry DB
		async function getUserInfoFromDB(_key, _keyType) { // blockchain, email or username
			console.log("function getUserInfoFromDB triggered * * * : " + _key + ", " + _keyType);

			return new Promise((resolve, reject) => {
				let postData = {
					type: 'query',
					query_type: 'latest',
					key: _key, // blockchain, email or username
					key_type: _keyType // 'email', 'bockchain', 'username', 'combined'
				};
				axios({ 
					url: USER_API_ENDPOINT_ROOT + "user-registry.php",
					method: "POST",
					data: JSON.stringify(postData),
				})
				.then((res) => { 
					const returned_data = JSON.parse(res.data.data);
					console.log("Check returned_data (user registry): ", returned_data);
					resolve(returned_data);
				}) 
				.catch((err) => { 
					console.log("error response: ", err);
				});
			});
		}

	// Check new user info against user registry DB, register if needed

		async function checkAndRegisterNewUser() {

			// Check & process user registration (with blockchain address)
				const bchain_account = await requestAccount()
				if (bchain_account == "error") {
					console.log("bc_account request failed");
				} else {
					console.log("Check bc account: " + bchain_account);
					setUserAddress(bchain_account); // set state
				}

			// Check user registration status with blockchain address
				if (bchain_account !== "error") { 
					const userArrayFromBchain_DB = await getUserInfoFromDB(bchain_account, 'blockchain');
					console.log("Check userArrayFromBchain_DB: ", userArrayFromBchain_DB);

					// If user is not in DB, request registration
						if (userArrayFromBchain_DB === 'none' && registerUser_state === false) {
							$(".user-info-required").show(300);
							setRegisterUser(true); // set state
							// window.scrollTo({ top: scrollTargetOffset, behavior: 'smooth' });
							return // prevent txn
					// If found...
						} else if (registerUser_state === false) { 
							// 
						}
				}

			// Check availability of username & email address (w/ off-chain DB)
				if (registerUser_state === true) { 
					const arrayFromNameDB = await getUserInfoFromDB(username, 'username'); // This 'username" variable from input box
					const arrayFromEmailDB = await getUserInfoFromDB(userEmail, 'email');
					$(".username-unavailable").hide(); //reset
					$(".userEmail-unavailable").hide(); // reset
					let check1 = false; let check2 = false;
					if (arrayFromNameDB !== 'none') { // If name already taken
						$(".username-unavailable").show(300);
						$(".user-info-fields").show(300);
						setErrorUsername(true);
						check1 = true;
					}
					if (arrayFromEmailDB !== 'none') { // If email already taken
						$(".user-email-unavailable").show(300);
						$(".user-info-fields").show(300);
						setErrorUserEmail(true);
						check2 = true;
					}
					if (check1 == true || check2 == true) { // Stop if any taken
						// window.scrollTo({ top: scrollTargetOffset, behavior: 'smooth' });
						return;
					}
				}

			// If all good, insert user/owner into into DB (if in 'create' mode)
				if (registerUser_state === true) { 
					const versionNum = 1;
					let DBupdateResult = await insertUserInfo('original', username, bchain_account, userEmail, versionNum); 
					console.log("DBupdateResult: ", DBupdateResult);
					if (DBupdateResult === 'success') {
						setRegisterUser(false); // reset
						$(".input-alert-area").hide(300);
					}
				}
		} // End checkAndRegisterNewUser()

	// Insert user info to user registry DB
		async function insertUserInfo(_update_type, _username, _bchain_address, _email, _version_num = 1) {
			console.log("function insertUserInfo triggered");
			console.log("Check _update_type: " + _update_type);
			console.log("Check _username: " + _username);
			console.log("Check _bchain_address: " + _bchain_address);
			console.log("Check _email: " + _email);
			console.log("Check _version_num: " + Number(_version_num));

			return new Promise((resolve, reject) => {
				let postData = {
					type: 'insert', // 'insert' or 'query'
					update_type: _update_type, // 'original' or 'update'
					username: _username,
					bchain_address: _bchain_address, 
					email: _email,
					version_num: _version_num
				};
				axios({ 
					url: USER_API_ENDPOINT_ROOT + "user-registry.php",
					method: "POST",
					data: JSON.stringify(postData),
				})
					.then((res) => { 
						const returned_data = JSON.parse(res.data);
						console.log("Check returned_data: ", returned_data);
						if (returned_data !== 'error') {
							resolve(returned_data);
						} else { 
							console.log("Could not insert data to DB!");
							resolve(null); 
						}
					}) 
					.catch((err) => { 
						console.log("error response: ", err);
					});
			});
		}


	// Blockhain transaction
	
		async function BlockchainTxn(_hashedTasking=null, _hashedTitle=null) {

			// Obtain user blockchain account
				const bchain_account = await requestAccount();
				if (bchain_account == "error") {
					console.log("bc_account request failed");
				}
				setUserAddress(bchain_account); // set state

				console.log("Check bc account: " + bchain_account);
				console.log("Check tasking hash: " + _hashedTasking);
				console.log("Check title hash: " + _hashedTitle);

			// Get user's initial max index value from smart contract
				let maxIndexBeforeTxn = await getMaxIndex();

				if (maxIndexBeforeTxn !== "error") {
					maxIndexBeforeTxn = Number(maxIndexBeforeTxn);
					let hasPreviousProject = maxIndexBeforeTxn > 0;

					// The contract's index remains 0 for both zero and one project,
					// so check whether the project at index 0 already exists.
					if (maxIndexBeforeTxn === 0) {
						try {
							const provider = new ethers.providers.JsonRpcProvider(PROVIDER_URL);
							const contract = new ethers.Contract(CONTRACT_ADDRESS, ProjectType1.abi, provider);
							const firstProjectKey = makeProjectKey(0, bchain_account);
							const firstProject = await contract.projects(firstProjectKey);
							hasPreviousProject = Number(firstProject.timeStamp || firstProject[3]) > 0;
						} catch (err) {
							console.error("Could not determine the next project index:", err);
							$(".bchain-button").show();
							$("#bchain-progress").hide();
							return;
						}
					}

					console.log("maxIndexBeforeTxn obtained:" + maxIndexBeforeTxn);
					$(".bchain-button").hide();
					$("#bchain-progress").show();

					// Submit project data to smart contract
					const transactionHash = await createProjectOnchain(_hashedTitle, _hashedTasking); // argument used because state variable for the hash doesn't work here
					console.log("transactionHash: " + transactionHash);
					if (transactionHash == "error") {
						console.log("Submit button reverted");
						$(".bchain-button").show();
						$("#bchain-progress").hide();
						alert("Transaction reverted!");
						return;
					} else {
						console.log("Prediction submission complete!");
					}

					// Avoid another wallet/RPC read after the transaction.
					const indexToStore = hasPreviousProject ? maxIndexBeforeTxn + 1 : 0;
					await storeInDatabase(transactionHash, indexToStore, bchain_account, _hashedTitle, _hashedTasking);
				} else { // if error (i.e. max index not obtained)
					console.log("Error: maxIndexBeforeTxn could not be obtained");
					$(".bchain-button").show();
					$("#bchain-progress").hide();
				}

		} // End of BlockchainTxn()


	// Store data in server database

		async function storeInDatabase(_txHash, _maxIndex, _bchainAccount, _hashedTitle = null, _hashedTasking = null) {

			console.log("storeInDatabase called");
			const bchain_account = _bchainAccount;
			// Produce project key
				const projectKey = makeProjectKey(_maxIndex, bchain_account);
			// Retrieve username from DB
				const userArrayFromBchain_DB = await getUserInfoFromDB(bchain_account, 'blockchain');
				const username_fn = userArrayFromBchain_DB['username'];
			console.log("002 Check project key: " + projectKey);
			console.log("002 Check bc account: " + bchain_account);
			console.log("002 Check username: " + username_fn);
			console.log("002 Check title hash: " + _hashedTitle);
			console.log("002 Check prediction hash: " + _hashedTasking);
			console.log("002 Check _maxIndex: " + _maxIndex);
			console.log("002 Check restrictionType: " + restrictionType);
			console.log("002 Check teamName: " + teamName);
			console.log("002 Check txHash: " + _txHash);

			// Get current time
				const currentTime = new Date().toISOString().slice(0, 19).replace('T', ' ');

			let postData = {
				index_num: _maxIndex,
				project_key: projectKey,
				submit_time: currentTime,
				bchain_account: bchain_account,
				username: username_fn,
				title: projectTitle,
				title_hash: _hashedTitle,
				open_time: openTime,
				close_time: closeTime,
				tasking_text: psiTaskingText,
				tasking_hash: _hashedTasking,
				file_name: fileNameFinal,
				file_hash: fileHash,
				restriction: restrictionType, // 'solo', 'open', or team key
				team_name: teamName,
				tx_hash: _txHash
			};
			axios({ 
				url: API_ENDPOINT_ROOT + "db-create-project.php",
				method: "POST",
				data: JSON.stringify(postData),
			})
			.then((res) => { 
				console.log("DB Result: ", res.data.result);
				jumpToProjectPage(projectKey);
			}) 
			.catch((err) => { 
				console.log("error response: ", err) 
				alert("Failed to store data in off-chain database!");
				$(".bchain-button").show();
				$("#bchain-progress").hide();
			});
		}

    // File upload

      const handleClick1 = e => {
        setIsActive(current => !current);
        setIsActive2(current => !current);
      };

      // Display file

        let fileName; let fileURL; let selectedFile;
        let btnUpload = $("#upload_file");
        let btnOuter = $(".button_outer");

        const displayFile = (e) => {

            selectedFile = e.target.files[0]
            fileName = btnUpload.val().split('\\').pop();
            let ext = btnUpload.val().split('.').pop().toLowerCase();

            let fileSize = selectedFile.size;
            console.log("File size check: " + fileSize);

            if($.inArray(ext, ['gif','png','jpg','jpeg','pdf']) == -1) {

                $(".error_msg").text("Invalid type (choose jpg, gif, png, or pdf)");

            } else if (fileSize > 20000000) {

                $(".error_msg").text("File is too big. Keep it under 20MB.");

            } else {

                $(".error_msg").text("");
                btnOuter.addClass("file_uploading"); // progress bar
                setTimeout(function(){
                    btnOuter.addClass("file_uploaded"); // done sign
                },1700);

                // selectedFile = e.target.files[0]
                console.log("Check #1: ", selectedFile)
                setFile(selectedFile); // set state

                e.target.value = ''; // Needed to allow same file being selected again

                if (ext == 'pdf') {
                  fileURL = ASSETS_FOLDER + 'pdf-icon-1.png';
                } else {
                  fileURL = URL.createObjectURL(selectedFile); // blob
                }

                setTimeout(function(){ // file image & file name
                    $("#uploaded_view").append("<img src='" +fileURL+ "' style='margin-top: 20px;' />").addClass("show");
                    $("#uploaded_view").append("<p style='color: gray !important; margin-top: 15px; font-size: 14px;'>" + fileName + "</p>");
                },2500);

                setTimeout(function(){ // remove button, progress bar & done sign
                    btnOuter.removeClass("file_uploading");
                    btnOuter.removeClass("file_uploaded");
                    $(".button_outer").hide();
                    $(".upload_button").show(); // Show upload button
                    $("#file-hashing-info").show();
                    $(".vertical-adj-1").show();
                    setBchainBtnDisabled(true);
                },2500);
            }
        }

      // Remove display
          $(".file_remove").on("click", function(e){
              $("#uploaded_view").removeClass("show");
              $("#uploaded_view").find("img").remove();
              $("#uploaded_view").find("p").remove(); // file name
              btnOuter.removeClass("file_uploading");
              btnOuter.removeClass("file_uploaded");
              $(".button_outer").show();
              $(".upload_button").hide();
              $("#loading-motion-1").find("p").remove();
              $("#loading-motion-1").hide(); 
              $(".vertical-adj-1").hide();
              $("#file-hashing-info").hide();
              setBchainBtnDisabled(false);
              setFile(''); // set state
              setFileHash('') // set state
          });

      // Upload file to Server
        async function handleSubmit(e, btn) {
          e.preventDefault();
          console.log("Button ID: " + btn);
          let loadingImgURL = ASSETS_FOLDER + 'loading.gif';

          if (btn == 1) {
              $(".upload_button").hide(); 
              $("#loading-motion-1").show(); 
              $("#loading-motion-1").append("<img width='70px' src='" +loadingImgURL+ "' style='margin-top: -15px;' />");
              $("#file-hashing-info").hide();
              uploadFile(fileSelected);
          }
        }

        async function uploadFile(_fileSelected) {

			// Checking
				console.log("check file selected: ",  _fileSelected);

			// Attached file
				let formData = new FormData();
				formData.append("file", _fileSelected);
				formData.append("uploads_folder", UPLOADS_FOLDER);
      
			axios({
				url: API_ENDPOINT_ROOT + "upload-file.php",
				method: "POST",
				data: formData,
			})
				// Handle the response from backend here
				.then((res) => { 
					console.log("File name: ", res.data.name);
					console.log("File hash: ", res.data.hash);
					setFileNameFinal(res.data.name);
					displayHash(res.data.hash);
				})        
				// Catch errors if any
				.catch((err) => { console.log("error response: " + err) });

			function displayHash(hashValue) {

				setFileHash(hashValue); // set state
				setTimeout(function(){ // time delay applied only when testing

					let displayHash = "Hash:<span style='color: rgba(0,0,0,0);'>|</span>" + hashValue;

					$("#loading-motion-1").find("img").remove();
					setBchainBtnDisabled(false);

					$("#loading-motion-1").append("<center><p style='margin-bottom: -30px; max-width: 315px; text-align: center; color: rgb(163, 163, 163) !important;'><span style='color: lightgreen; font-weight: bold'>READY </span><br/><span style='overflow-wrap: break-word; font-size: 14px;'>(" + displayHash + ")</p></center>");

					$("#uploaded_view").find("p").remove();

					window.scrollTo(0, document.body.scrollHeight) // scroll to bottom

				},1400); // 3400
			}

        }


    // Prepare data for blockchain & server DB (triggered via "Save to Blockchain" button)

        async function validateAndSaveToBchainAndDB() {

			// Reset alert area
				console.log("========================");
				console.log('username: ' + username);
				console.log('userEmail: ' + userEmail);
				console.log('registerUser_state: ' + registerUser_state);
				$(".input-alert-area").hide(300);
				$(".username-unavailable").hide(300);
				$(".user-email-unavailable").hide(300);
				$(".user-info-required").hide(300);

			// If in teams mode, check team selection; stop txn if no team selected
				if (restrictionType == 'team') {
					console.log("selectedValue (team selected): " + selectedValue);
					if (selectedValue == null || selectedValue == " You have no teams") {
						alert("Please select a team");
						return;
					}
				}

			// Validate text/date fields

				// Check time
					let timeDateError1_ = false;
					let timeDateError2_ = false;
					if (JSON.stringify(dayjs()) > JSON.stringify(timeValue)) {

						setTime(dayjs(JSON.stringify(timeValue))); // this triggers error red color (because min time has changed)

						console.log("timeValue: " + JSON.stringify(timeValue));
						setTimeDateError1(true);
						timeDateError1_ = true;
						console.log("timeDateError (1): " + timeDateError1_);
					} else if (JSON.stringify(dayjs()) >= JSON.stringify(timeValue_2) || JSON.stringify(timeValue) >= JSON.stringify(timeValue_2)) {

						setTime_2(dayjs(JSON.stringify(origTime_2))); // this triggers error red color (because min time has changed)

						console.log("timeValue_2: ", JSON.stringify(timeValue_2));
						console.log("origTime_2: ", origTime_2);
						setTimeDateError2(true);
						timeDateError2_ = true;
						console.log("timeDateError (2): " + timeDateError2_);
					}
				// Check project title
					if (projectTitle) { setErrorTitle(false) } else { setErrorTitle(true) }
				// Check tasking text
					if (psiTaskingText) { setErrorTasking(false) } else { setErrorTasking(true) }
				// IF in 'register' mode, check username & email address
					if (registerUser_state === true) {
						if (username) { setErrorUsername(false) } else { setErrorUsername(true) }
						if (userEmail) { setErrorUserEmail(false) } else { setErrorUserEmail(true) }
					}
				// IF any error (empty), STOP txn
					let invalidStop = false;
					if (timeDateError1_ == true || timeDateError2_ == true || !projectTitle || !psiTaskingText) { 
						invalidStop = true;
						window.scrollTo({ top: scrollTargetOffset, behavior: 'smooth' });
					}
					if (registerUser_state == true) {
						if (!username || !userEmail) {  
							invalidStop = true;
							$(".user-info-required").show(300);
						}
					}
					if (invalidStop === true) {
						// window.scrollTo({ top: scrollTargetOffset, behavior: 'smooth' });
						console.log("invalidStop = true");
						return;
					}

			// Check user wallet, registration (register new user if needed)

				await checkAndRegisterNewUser();

			// Check available variables
				console.log("- Title: " + projectTitle);
				console.log("- openTime: " + openTime);
				console.log("- closeTime: " + closeTime);
				console.log("- psiTaskingText: " + psiTaskingText);
				console.log("- FileHash: " + fileHash);
				console.log("- restrictionType: " + restrictionType);

			// Hash project title & tasking text (SHA-256)
				console.log("Hashing started")
				const hashedProjectTitle = await hashData(projectTitle);
				const hashedTasking = await hashData(psiTaskingText);
				console.log("Hashing complete");

			await BlockchainTxn(hashedTasking, hashedProjectTitle);

        }  // End of validateAndSaveToBchainAndDB


    // Switch to "Project" page showing project info just recorded on blockchain
        function jumpToProjectPage(_projectKey) {
            setTimeout(function() {
                navigate('/project?key=' + _projectKey + "&cfm=true");
            }, 1000); // delay of 1 sec
        }

    // Functions for blockchain transaction

        // request access to the user's MetaMask account
			async function requestAccount() {
				try {
					const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
					const bc_account = accounts[0]
					setUserAddress(bc_account); // set state
					return bc_account
				} catch(err) {
					console.log("Error: ", err);
					$(".bchain-button").show();
					$("#bchain-progress").hide();
					return "error"
				}
			}

        async function createProjectOnchain(_hashedTitle = null, _hashedTasking = null) {

			console.log("createProjectOnchain check 1")

			if (typeof window.ethereum !== 'undefined') {

				console.log("createProjectOnchain check 2")

				const provider = new ethers.providers.Web3Provider(window.ethereum)
				const signer = provider.getSigner();
				const contract = new ethers.Contract(CONTRACT_ADDRESS, ProjectType1.abi, signer);

				// Prepare
					console.log("createProjectOnchain check 3")
					let txHash_fn, hashedRestriction;

					const bchain_account = await requestAccount();
					const userArrayFromBchain_DB = await getUserInfoFromDB(bchain_account, 'blockchain');
					const _username = userArrayFromBchain_DB['username'];
					// Hash restriction (Solidity compatible)
					if (restrictionType == 'open' || restrictionType == 'solo') {
						// let restrictionBytes = ethers.utils.toUtf8Bytes(restrictionType);
						// hashedRestriction = ethers.utils.keccak256(restrictionBytes);
						hashedRestriction = await hashSolidityStyle(restrictionType);
					} else { // if team key
						hashedRestriction = teamKey;
					}
					console.log("hashedRestriction: " + hashedRestriction);
					console.log("fileHash: " + fileHash);
					console.log("hashedTasking: " + _hashedTasking);
					console.log("hashedTitle: " + _hashedTitle);
					console.log("username: " + _username);

				// Start transaction
					try {
						console.log("createProjectOnchain check 4")
						const transaction = await contract.createProject(_hashedTitle, _username, openTime, closeTime, _hashedTasking, fileHash, hashedRestriction);
						// Wait for mining through the app's independent RPC endpoint,
						// not MetaMask's injected provider, which may report receipts late.
						const receiptProvider = new ethers.providers.JsonRpcProvider(PROVIDER_URL);
						const receipt = await receiptProvider.waitForTransaction(transaction.hash, 1, 120000);
						if (!receipt || receipt.status !== 1) {
							throw new Error("Transaction was not confirmed successfully by the RPC provider.");
						}

						console.log("createProjectOnchain check 5")
						console.log("txHash: " + receipt.transactionHash);
						setTxHash(receipt.transactionHash); // set txHash
						txHash_fn = receipt.transactionHash;
					} catch (err) {
						console.log("Error: ", err);
						txHash_fn = "error";
						$(".bchain-button").show();
						$("#bchain-progress").hide();
						// Add error handler here
					}

				return txHash_fn;

			} else {

				console.log("createProjectOnchain failed")
			}
        }


        async function getMaxIndex() {

          console.log('getMaxIndex called');
          if (typeof window.ethereum !== 'undefined') {
              const bc_account = await requestAccount();
              console.log('Check user address: ' + bc_account);
              const provider = new ethers.providers.Web3Provider(window.ethereum);
              const contract = new ethers.Contract(CONTRACT_ADDRESS, ProjectType1.abi, provider);
            try {
				console.log("getMaxIndex check 1");
                let data = await contract.getMaxIndex(bc_account);
                data = Number(data);
                console.log('Max index: ', data);
                return data;
            } catch (err) {
                console.log("getMaxIndex Error: " + err);
                console.log("Provider temporarily switching to Alchemy");
                let data2 = await getMaxIndex_secondaryAPI(bc_account);
                return data2
            }
          }    
        }

        async function getMaxIndex_secondaryAPI(_bc_account) {
            const provider2 = new ethers.providers.JsonRpcProvider(PROVIDER_URL);
            const contract2 = new ethers.Contract(CONTRACT_ADDRESS, ProjectType1.abi, provider2);
            try {
                let data = await contract2.getMaxIndex(_bc_account);
                data = Number(data);
                console.log('Max index (alt. RPC): ', data);
                return data;
            } catch (err) {
                console.log("getMaxIndex Error (alt. RPC): " + err);
                $(".bchain-button").show();
                $("#bchain-progress").hide();
                return "error";
            }
        }


    // Manage time
        const [timeValue, setTime] = useState(dayjs()); // open date/time
		const [timeValue_2, setTime_2] = useState(dayjs()); // close date/time
		const [origTime, setOrigTime] = useState(dayjs()); // existing open date/time
        const [origTime_2, setOrigTime_2] = useState(dayjs()); // existing close date/time
        const [minTimeValue, setMinTime] = useState(dayjs()); // minimum date/time for open
		const [minTimeValue_2, setMinTime_2] = useState(dayjs()); // minimum date/time for close

		// Open date (mmm/dd/yyyy)
        const handleDateChange_1 = (newValue) => { 
			setOrigTime(newValue);
			setTime(dayjs(newValue));
			let timeUnix = new Date(newValue).getTime();
			// let timeUnix = Math.floor(new Date(newValue).getTime() / 1000);
			// setTime(timeUnix);
			setOpenTime(timeUnix);
			setMinTime_2(newValue); // For close date & time

			console.log("Open date (& time): ", JSON.stringify(newValue));
			console.log("Open date (& time) UNIX: " + timeUnix);

			// Check against current time
			if (JSON.stringify(newValue) > JSON.stringify(dayjs())) { 
				console.log("Open date (& time) - in future (valid)");
				setMinTime(dayjs('2018-01-01T00:00')); // get rid of min time this way here so 'open time' (hr & min) display doesn't exclude any time (carried over from initial hr/min time dislpay set to current time)
			} else { 
				console.log("Open date (& time) - in past (invalid)");
				setMinTime(dayjs());
				setTime(dayjs()); // added 8/2/24
				setOpenTime(dayjs()); // added 8/2/24
				setMinTime_2(dayjs()); // added 8/2/24
			}
			// Check against existing close date/time
			if (JSON.stringify(newValue) >= JSON.stringify(origTime_2)) {
				// Push forward close date/time to match open date/time
				handleDateChange_2(newValue);
				handleTimeChange_2(newValue);
			} else {
				// Keep close date/time as is
				handleDateChange_2(origTime_2);
				handleTimeChange_2(origTime_2);
			}
        };

		// Open time (hr:min am/pm)
        const handleTimeChange_1 = (newValue) => { 
			setOrigTime(newValue); 
			setMinTime_2(newValue); // For close date & time
			setTime(dayjs(newValue));
			let timeUnix = new Date(newValue).getTime();
			// setTime(timeUnix);
			setOpenTime(timeUnix);

			console.log("Open time (& date): ", JSON.stringify(newValue));
			console.log("Opne time (& date) UNIX: " + timeUnix);

			// Check against existing close date/time
			if (JSON.stringify(newValue) > JSON.stringify(origTime_2)) {
				// Push forward close date/time to match open date/time
				handleDateChange_2(newValue);
				handleTimeChange_2(newValue);
			} else {
				// Keep close date/time as is
				handleDateChange_2(origTime_2);
				handleTimeChange_2(origTime_2);
			}
        };

		// Close date
		const handleDateChange_2 = (newValue) => { 
			setOrigTime_2(newValue);
			setTime_2(dayjs(newValue));
			let timeUnix = new Date(newValue).getTime();
			// setTime_2(timeUnix);
			setCloseTime(timeUnix);

			console.log("CloseTime: ", JSON.stringify(newValue));
			console.log("CloseTime UNIX: " + timeUnix);

			analyzeAndSetMinTime_2(newValue);
			handleTimeChange_2(newValue);
        };

		// Close time
        const handleTimeChange_2 = (newValue) => { 
			analyzeAndSetMinTime_2(newValue);
			setTime_2(dayjs(newValue));
			let timeUnix = new Date(newValue).getTime();
			// setTime_2(timeUnix);
			setCloseTime(timeUnix);
			console.log("closeTime: ", JSON.stringify(newValue));
			console.log("closeTime UNIX: " + timeUnix);
			if (JSON.stringify(newValue) > JSON.stringify(dayjs())) {
				console.log("Close time (& date) entered by user")
			} else { 
				console.log("Close time (& date) has not been entered by user")
			}
        };

		function analyzeAndSetMinTime_2(newValue) {

			console.log("====== Analyze and set min time 2 triggered");
			let timeUnix = new Date(newValue).getTime();

			// Compare newValue to origTime and if the former is lesser, set setMinTime_2 to origTime
				if (newValue < origTime) {
					console.log("Close date (y/m/d) is lesser than origTime");
					setMinTime_2(origTime);
				} 
			// If newValue's date (ignoring the hr/min/sec part, use only the date i.e. year, month, and day) is greater than origTime, set setMinTime_2 to '2018-01-01T00:00'
				// Set hours, minutes, and seconds of timeUnix (newValue in UNIX) to zero
					const dateObj = new Date(timeUnix);
					dateObj.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
					const dateOnlyUnix = dateObj.getTime();
			
				// Compare newValue to origTime and if the former is greater, set setMinTime_2 to '2018-01-01T00:00'
					console.log("origTime: " + origTime);
					console.log("origTime UNIX date only: ", new Date(origTime).setHours(0, 0, 0, 0));
					console.log("newValue: " + newValue);
					console.log("newValue UNIX date only: ", dateOnlyUnix);
					
					if (dateOnlyUnix > new Date(origTime).setHours(0, 0, 0, 0)) {
						console.log("Close date (y/m/d) farther than origTime date");
						setMinTime_2(dayjs('2018-01-01T00:00'));
					}
		}


    // Prepare texts
        const infoHashingText = "Hashing means the information/file you enter will be obfuscated and represented only by its cryptographic 'fingerprint' - a series of numbers and characters called a 'hash'. If you choose this option <span style='color:rgb(255, 133, 133)';>only the hash of the original information will be stored on blockchain and publicly displayed</span> (until you 'pin' the information later). This is to ensure privacy and security while maintaining verifiability. <br/><br/>The hash will be generated using the SHA-256 algorithm, a widely used and secure hashing algorithm. <br/><br/>The hash will be generated on your device and then sent to blockchain and the server. <br/><br/> <span style='color:rgb(255, 133, 133)';>Important:</span> Please keep an exact copy of your text/file with you as it may be required for authentification purposes later especially if you decide to NOT keep the original text/file on the Psiscope server. During the verification process, the original text/file will be hashed as before and then compared to the hash stored on blockchain. They should be identical, otherwise the text/file is deemed invalid.";

        const infoHashingFile = "Only the 'hash', or the cryptographic 'fingerprint', of the file will be stored on blockchain. The file itself will be stored on the off-chain server.";

        let newTabOpenImg = ASSETS_FOLDER + 'ext-link-icon.png';

        const infoBlockchain = "To make your information immutable & irrefutable it needs to be stored on blockchain. To store it on blockchain you need a cyrpto/Web3 wallet installed on your browser or use a wallet app on your mobile device. Then with this wallet you can 1) connect to blockchain, 2) store information onchain, and 3) pay a tiny transaction fee. (Reading from blockchain is free, writing to it is not, though it's so cheap it's practically free.) <br/><br/>If you are new to blockchain and worry that connecting a wallet (Web3 equivalent of 'log in') sounds unsafe, <a href='./faq' target='_blank'>please see FAQ</a> <img src=" + newTabOpenImg + " width='17px'> for more information. Being careful is wise but there's no need to be overly paranoid. <br/><br/>Note: If you already have a wallet with a lot of assets in it, you can create a separate account inside your wallet and use it with Psiscope if you want to feel extra safe.";

    // Hashing help info show/hide
        // const [hashingInfo, setHashingInfo] = React.useState(false);
        const [bchainInfo, setBchainInfo] = React.useState(false);
        
        // const HandleHashingInfoClick = () => { 

        //     if (hashingInfo == false) {
        //         setHashingInfo(true);
        //         $('#hashing-help-info').html('');
        //         $('#hashing-help-info').append(infoHashingText);
        //         $('#hashing-help-info').show(200);
        //         $('.hashing-help-info-gap').show();
        //     } else {
        //         setHashingInfo(false);
        //         $('#hashing-help-info').hide(400);
        //         $('#hashing-help-info').html('');
        //         $('.hashing-help-info-gap').hide();
        //     }
        // };

    // Blockchain help info show/hide 
        const HandleBchainInfoClick = () => { 

            if (bchainInfo == false) {
                setBchainInfo(true);
                $('#blockchain-help-info').html('');
                $('#blockchain-help-info').append(infoBlockchain);
                $('#blockchain-help-info').show(200);
            } else {
                setBchainInfo(false);
                $('#blockchain-help-info').hide(400);
                $('#blockchain-help-info').html('');
            }
        };

    // Handle restriction toggle
		const handleRestrictionToggle = (event, selection) => {
			console.log("handleRestrictionToggle called");
            setRestrictionType(selection);
            if (selection == 'team') {
                $('.search-box').show(300);
                $('.restriction-note').hide(300);
				setSelectedValue(null); // Reset the search box text display
            } else if (selection == 'open') {
                $('.search-box').hide(300);
                $('.restriction-note').show(300);
            } else if (selection == 'solo') {
				$('.search-box').hide(300);
				$('.restriction-note').show(300); // Change this * * *
			}
			if (selection != 'team') {
				setTeamKey(null); // Reset team key
				setTeamName(null); // Reset team name
			}
        };

    // Set dark theme
        const darkTheme = createTheme({
          palette: {
            mode: 'dark',
          },
        });



    return (

        <div className="App-container">

            {/* <React.Fragment> */}
            <ThemeProvider theme={darkTheme}>
              <CssBaseline />
              {/* <Container maxWidth="md" style={{ border: "0px solid red"}}> */}

                {/* Mobile Nav Buttons*/}

					<div className="mobile-nav-buttons" style={{border:"0px solid red", margin:"auto", marginTop:"-15px", display:"none"}}>

						<Button size="small" sx={{ my: 2, color: 'lightgray' }} style={{ marginLeft:"5px", marginTop:'17px'}} onClick={ () => setupBlockchain('skip wallet prompt') } >
							<Link className="nav-menu-mobile" to="/create" style={{ fontSize:'16px', fontWeight:'normal', color:'white' }}>Create</Link>
						</Button>

						<div style={{ color:'gray', display:'inline-block' }}>|</div>

						<Button size="small" sx={{ my: 2, color: 'lightgray' }} style={{ marginLeft:"3px", marginTop:'17px'}}>
							<Link className="nav-menu-mobile" to="/browse" style={{ fontSize:'16px', fontWeight:'normal', color:'white' }}>Browse</Link>
						</Button>

						<div style={{ color:'gray', display:'inline-block' }}>|</div>

						<Button size="small" sx={{ my: 2, color: 'lightgray' }} style={{ marginLeft:"-5px", marginTop:'17px'}}>
							<Link className="nav-menu-mobile" to="/faq" style={{ fontSize:'16px', fontWeight:'normal', color:'white' }}>FAQ</Link>
						</Button>
					</div>

                <div className="app-title" style={{ margin:"13px 0px 0px" }}>
					PROJECT TYPE-1
                </div>

                {/* gray box */}

                <div className='address-input-section' style={{ margin:"auto", marginTop: '30px', marginBottom:"-20px", maxWidth:'670px', border:"1px solid rgb(87, 87, 87)", backgroundColor: 'rgba(255, 255, 255, 0.025)', padding:'15px', paddingTop:'35px', paddingBottom:'50px' }}>

                <div className="subheading" id="subheading" style={{ marginTop: "-5px", marginBottom: "-30px" }}>C R E A T E</div>

                <br/><br/>

                <Box
                  component="form"
                  sx={{
                    '& > :not(style)': { m: 1, width: '27ch' },
                  }}
                  noValidate
                  autoComplete="off"
                >

                    <TextField 
                        id="TRN-field" 
                        label="Project Name" 
                        helperText="Kept hidden while project is active"
                        variant="standard" 
                        error={errorTitle} 
                        onChange={(event) => {setTitle(event.target.value)}} 
					/>

                    {/* <TextField 
                        id="username-field" 
                        label="Project Manager Name" 
                        helperText="Any name you choose or already chosen (this is secondary to wallet address)"
                        variant="standard" 
                        error={errorUsername} 
                        onChange={(event) => {setUsername(event.target.value)}} /> */}

				</Box>

				<Root>
					<Divider className='width-control-1' style={{ margin:'auto', marginTop:'30px', marginBottom:'20px', maxWidth:'500px'}}>OPENS AT</Divider>
				</Root>

				<LocalizationProvider dateAdapter={AdapterDayjs}>
				<Box
					component="form"
					sx={{
					'& > :not(style)': { m: 1, width: '27ch' },
					}}
					noValidate
					autoComplete="off"
                >

                    {/* <LocalizationProvider dateAdapter={AdapterDayjs}> */}

                        <MobileDatePicker
							label="OPEN Date"
							value={timeValue}
							onChange={handleDateChange_1}
							minDate={dayjs()}
							slotProps={{
								textField: {
								variant: 'standard',
								error: timeDateError1
								// helperText: timeDateError ? "Enter date here." : ""
								}
							}}
						/>

                        <TimePicker
							label="OPEN Time"
							value={timeValue}
							onChange={handleTimeChange_1}
							minTime={minTimeValue}
							slotProps={{
								textField: {
								variant: 'standard',
								error: timeDateError1
								// helperText: timeDateError ? "Enter time here." : ""
								}
							}}
						/><br/><br/>

				</Box>
				</LocalizationProvider>

				<Root>
					<Divider className='width-control-1' style={{ margin:'auto', marginTop:'0px', marginBottom:'20px', maxWidth:'500px'}}>CLOSES AT</Divider>
				</Root>

				<LocalizationProvider dateAdapter={AdapterDayjs}>
				<Box
					component="form"
					sx={{
					'& > :not(style)': { m: 1, width: '27ch' },
					}}
					noValidate
					autoComplete="off"
                >

                        <MobileDatePicker
							label="CLOSE Date"
							value={timeValue_2}
							onChange={handleDateChange_2}
							minDate={minTimeValue_2}
							slotProps={{
								textField: {
								variant: 'standard',
								error: timeDateError2
								}
							}}
						/>
                        <TimePicker
							label="CLOSE Time"
							value={timeValue_2}
							onChange={handleTimeChange_2}
							minTime={minTimeValue_2}
							slotProps={{
								textField: {
								variant: 'standard',
								error: timeDateError2
								}
							}}
						/>

                    {/* </LocalizationProvider> */}

                </Box>
				</LocalizationProvider>


                {/* Horizontal divider */}
					<Root>
						<Divider className='width-control-1' style={{ margin:'auto', marginTop:'30px', marginBottom:'20px', maxWidth:'500px'}}>PSI TASKING</Divider>
					</Root>

                <Box
                    className = "width-control-1"
                    sx={{
                      '& > :not(style)': { m: 0 },

                      width: 495, // 547
                      maxWidth: '100%',
                      margin: "auto",
                      marginTop: "15px",
                      marginBottom: "-55px",
                    }}
                >
                    <TextField 
						// variant="outlined"
						// InputLabelProps={{ shrink: true }}
						// sx={{
						// 	'& .MuiOutlinedInput-root': {
						// 		'& legend': {
						// 			maxWidth: '1000px', // allow full label to display
						// 		},
						// 	},
						// }}
						error={errorTasking}
						fullWidth
						id="outlined-textarea"
						label="Target / Tasking / Cue / Etc."
						// placeholder="Your Prediction"
						multiline
						minRows={4}
						// onChange={(event) => {setPsiTasking(event.target.value)}}
						onChange={handleTextChange}
                    />
                </Box>

                <br/><br/>

                {/* <FormGroup 
                    className = "width-control-1"
                    sx={{
                      '& > :not(style)': { m: 0 },
                      border: '0px solid blue',
                      width: 495,
                      maxWidth: '100%',
                      margin: "auto",
                      marginTop: "15px",
                      marginBottom: "-70px",
                    }}>
                    <FormControlLabel style={{ color: "lightgray"}}
                    control={<Switch size="small" checked={predictionIsHashed} onChange={(event) => {setPsiTaskingHashed(event.target.checked)}} />} label="Hash prediction" />
                </FormGroup> */}

                {/* <HelpOutline 
                    className = "width-control-1 width-control-2"
                    onClick={HandleHashingInfoClick}
                    sx={{
                      '& > :not(style)': { m: 0 },
                      color: "lightblue",
                      width: 495, // 30
                      maxWidth: '100%',
                      margin: "auto",
                      marginTop: "20px",
                      marginBottom: "-51px", // -70
                      marginLeft: "-162px",
                      fontSize: "20px",
                    }} 
                />  */}

                {/* Warning text about hashing */}
                  {/* { predictionIsHashed ? 
                    (<div style={{border: '0px solid red', margin: 'auto', marginTop: '65px', marginBottom: '-65px', maxWidth: '495px', padding:'0px 10px', color: 'rgb(255, 133, 133)', fontSize: '16px', textAlign: 'center' }}>Make sure to keep with you an exact copy of your prediction! <br/>Make sure there are no line breaks (keep it all in 1 paragraph)!</div>
                    ) : (<div style={{ dislpay:'none'}}></div>) 
                  } */}
                {/* Vertical gap control */}
                  {/* <div className='hashing-help-info-gap' style={{ display: 'none' }}>
                      { predictionIsHashed ? 
                        (<div style={{ marginTop: '0px' }}><br/></div>
                        ) : (<div style={{ dislpay:'none'}}></div>) 
                      }
                  </div> */}
                {/* Help text appears here */}
                  {/* <div id='hashing-help-info' style={{border: '0px solid red', margin: 'auto', marginTop: '65px', marginBottom: '-65px', maxWidth: '495px', padding:'0px 10px', color: 'lightgray', fontSize: '16px', textAlign: 'left', display: 'none'}}>
                  </div> */}
                    
                {/* <div style={{marginBottom: "-25px"}}></div> */}

              {/* </Container>
            </ThemeProvider> */}
            {/* </React.Fragment> */}


            <div style={{marginBottom: "-70px"}}></div>

            {/* <ThemeProvider theme={darkTheme}>
            <div className="container"> */}
              <div className="panel">

				<div id="file-hashing-info" className='width-control-1' style={{margin: 'auto', color: 'lightgray', fontSize: '14px', textAlign: 'left', maxWidth: '460px', display: 'none'}}>{infoHashingFile}</div>

				<Button className="upload_button" variant="outlined" size="large" style={{ margin: "auto", marginTop:'25px', marginBottom:'0px', fontWeight: "bold", display: "none"}} onClick={(e) => handleSubmit(e, 1)} >Click to Confirm</Button>

				<div id="loading-motion-1" style={{display: 'none'}}></div>

				<center>
				<div className="button_outer {isActive ? 'file_uploading' : ''} {isActive2 ? 'file_uploaded' : ''}" onClick={handleClick1} >

					<div className="btn_upload" style={{fontWeight: 'normal'}}>
						<input type="file" id="upload_file" name="" onChange={(evt) => displayFile(evt)} />Attach File?
					</div>
					<div className="processing_bar"></div>
					<div className="success_box"></div>

				</div>
				</center>

              </div>
              <div className="error_msg"></div>
              <div className="uploaded_file_view" id="uploaded_view">
                <span className="file_remove">X</span>
              </div>

            {/* </div> */}


            {/* Horizontal divider */}
				<div className='vertical-adj-1' style={{ marginTop:'120px', display: 'none'}}></div>
				{/* <center><div className='width-control-1' style={{margin: 'auto', margin: '-80px 0px 28px', borderTop: '1px rgb(98, 98, 98) solid', maxWidth: '500px'}}></div></center> */}
				<Root>
					<Divider className='width-control-1' style={{ margin:'auto', marginTop:'-65px', marginBottom:'20px', maxWidth:'500px'}}>RESTRICTION</Divider>
				</Root>


			{/* Restriction section */}

            <div style={{ marginTop: "35px", marginBottom: "135px"}}>
                <ToggleButtonGroup
                    color="primary"
                    value={restrictionType}
                    exclusive
                    onChange={handleRestrictionToggle}
                    aria-label="Platform"
                    size='small'
                >
                    <ToggleButton value="open">Open</ToggleButton>
                    <ToggleButton value="team">Team</ToggleButton>
                </ToggleButtonGroup>
            </div>

            <div className='restriction-note width-control-1' style={{ border:'0px solid red', minWidth:'310px', margin: 'auto', marginTop:'-117px', marginBottom:'50px', color:'rgb(181, 181, 181)', fontSize:'15px'}}>
                "Open" means open to everyone.<br/>
				Select "Team" to restrict participation.
            </div>

				{/* Virtualized search box * * * */}

				<div className='search-box' style={{ marginTop:'-105px', marginBottom:'-60px', display: 'none' }}>

					{/* <FormHelperText style={{ textAlign:'center', fontSize:'13px'}}><span style={{color:'rgb(156, 156, 156)'}}>Search with address, username or title</span></FormHelperText> */}

					<Autocomplete
						id="search-box"
						sx={{ maxWidth: 300, margin: 'auto', marginBottom: '120px' }}
						disableListWrap
						PopperComponent={StyledPopper}
						ListboxComponent={ListboxComponent}
						options={OPTIONS}
						groupBy={(option) => option[0].toUpperCase()}
						value={selectedValue} // Needed only when resetting the search box text display, which this app needs
						renderInput={(params) => 
							<TextField {...params} label="Search" />}
						renderOption={(props, option) => [props, option]}
						renderGroup={(params) => params}

						onChange={(event, newValue) => {
							console.log("newValue: " + newValue);
							setSelectedValue(newValue); // value selected
							// Find team key for selectded team and set state
							for (let i = 0; i < searchList.length; i++) {
								if (searchList[i] == newValue) {
									console.log("Matching team name found in DB: " + teamIndexList[i]);

									let inputData = ethers.utils.solidityPack(['uint256', 'address'], [teamIndexList[i], userAddress]);
									let _teamKey = ethers.utils.keccak256(inputData);

									setRestrictionType(_teamKey);
									setTeamKey(_teamKey); // set team key state
									setTeamName(newValue); // set team name state
									console.log("Team key set: " + _teamKey);
								}
							}
						}}
						// onInputChange={(event, newInputValue) => {
						// 	setInputValue(newInputValue);
						// }}
					/>
				</div>

				{/* End virtualized search box */}
			{/* End restriction section * * * */}


            <center>
                <div className='vertical-adj-2' style={{display: 'none'}}></div>
				<Root>
					<Divider className='width-control-1' style={{ margin:'auto', marginTop:'-10px', marginBottom:'30px', maxWidth:'500px'}}>SAVE & LAUNCH</Divider>
				</Root>


				{/* User Info Required */}

					<Box
					className='user-info-required user-info-fields'
					style={{ margin:'-25px 0px 40px', display:'none'}}
					component="form"
					sx={{
						'& > :not(style)': { m: 1, width: '27ch' },
					}}
					noValidate
					autoComplete="off"
					>
						<TextField 
							id="username-field" 
							label="Username" 
							// helperText="Nickname, real name, ENS, cb.id, etc." 
							helperText="Choose your public username"
							variant="standard" 
							error={errorUsername} 
							onChange={(event) => {setUsername(event.target.value)}} />

						<TextField 
							id="owner-email-field"
							label="Email Address"
							helperText="This will be kept OFF-chain and private"
							variant="standard" 
							error={errorUserEmail} 
							onChange={(event) => {setUserEmail(event.target.value)}} />
							
					</Box>

				{/* Alerts * * * */}
					<center>
					<div className='user-info-required input-alert-area' style={{ margin:'-18px 0px 38px', maxWidth:'500px', color:'rgb(255, 166, 166)', fontSize:'15px', display:'none'}}>Your blockchain address is new to the system. Please choose a public username. Your email will be kept off-chain, private, and changeable.</div>

					<div className='username-unavailable input-alert-area' style={{ margin:'-18px 0px 38px', color:'rgb(255, 145, 145)', fontSize:'16px', display:'none'}}>This username belongs to someone else! Please choose a different name.</div>

					<div className='user-email-unavailable input-alert-area' style={{ margin:'-18px 0px 38px', color:'rgb(255, 145, 145)', fontSize:'16px', display:'none'}}>This email address is used by someone else! Please use a different one.</div>
					</center>
				{/* End Alerts * * * */}

				{/* ------- */}

                  <Button className='bchain-button' variant='contained' style={{fontWeight: 'bold', color: 'rgb(47, 70, 117)', display: 'none'}} disabled={ bchainBtnDisabled } onClick={validateAndSaveToBchainAndDB}>
                    Save to Blockchain
                  </Button>

                  <Button className='connect-wallet-button' variant='contained' style={{backgroundColor: 'rgb(207, 154, 151)', fontWeight: 'bold', color: 'rgb(47, 70, 117)', display: 'block'}} disabled={ bchainBtnDisabled } onClick={connectWallet}>
                    Connect (Blockchain)
                  </Button>

                  <Button className='switch-chain-button' variant='contained' style={{backgroundColor: 'rgb(239, 223, 143)', fontWeight: 'bold', color: 'rgb(47, 70, 117)', display: 'none'}} disabled={ bchainBtnDisabled } onClick={switchNetwork}>
                    Switch Network
                  </Button>

					<Box id='bchain-progress' style={{display: 'none'}}>
						<br/><div style={{ color:'white'}}>Please wait...</div><br/>
						<CircularProgress />
					</Box>

                  {/* Blockchain help text */} 

                    <div className="bchain-help-section" style={{ display:"none"}}>

                      <HelpOutline 
                          className = "width-control-1 width-control-2"
                          onClick={HandleBchainInfoClick}
                          sx={{
                            '& > :not(style)': { m: 0 },
                            color: "lightblue",
                            width: 300, // 30
                            maxWidth: '100%',
                            margin: "auto",
                            // marginTop: "-17x",
                            marginBottom: "-23px",
                            marginLeft: "91px",
                            fontSize: "20px",
                            border: "0px solid green",
                          }} 
                      /> 

                      <div style={{ border:"0px solid red", maxWidth: '405px', margin: 'auto', color: 'rgb(200, 200, 200)', fontSize:"15px" }}>
                        <center style={{ marginTop:"-4px", marginLeft:"-21px"}}>
                          What is this?
                        </center>
                      </div>

                      <div id='blockchain-help-info' className='hyperlink' style={{border: '0px solid red', margin: 'auto', marginTop: '18px', maxWidth: '495px', padding:'0px 10px', color: 'lightgray', fontSize: '16px', lineHeight: '1.5', textAlign: 'left', display: 'none'}}></div>

                    </div>
                  {/* end blockchain help text */}

            </center>

			</div> {/* End gray box */}

			{/* </Container> */}
            </ThemeProvider>

            <br/><br/><br/><br/>

        </div>
    );

}


export default Create;
